export default "__VITE_ASSET__BONDMm8Z__"